import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=02f2f944&"
import script from "./ProductEditor.vue?vue&type=script&lang=ts&"
export * from "./ProductEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&id=02f2f944&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports